export default __webpack_public_path__ + "static/news31-83174ae22a85bfb64dcd2bfff00bd9cb.png";